import { NgModule }                from '@angular/core';
import { CommonModule }            from '@angular/common';
import { MaterialModule }          from '@angular/material';
import { A2CardComponent }         from '../ni-components/card/card.component';
import { AlertComponent }          from '../ni-components/alert/alert.component';
import { BadgeComponent }          from '../ni-components/badge/badge.component';
import { BreadcrumbComponent }     from '../ni-components/breadcrumb/breadcrumb.component';
import { FileComponent }           from '../ni-components/file/file.component';

//import { NIHTimelineComponent }  from '../ni-components/ni-h-timeline/ni-h-timeline.component';
@NgModule({
  declarations: [
    A2CardComponent,
    AlertComponent,
    BadgeComponent,
    BreadcrumbComponent,
    FileComponent
    //NIHTimelineComponent
  ],
  exports: [
    A2CardComponent,
    AlertComponent,
    BadgeComponent,
    BreadcrumbComponent,
    FileComponent,
    MaterialModule
    //NIHTimelineComponent
  ],
  imports: [
    CommonModule,
    MaterialModule
  ]
})
export class NIModule { }



// WEBPACK FOOTER //
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/ni-components/ni.module.ts